import Image from 'next/image';
import { useRouter } from 'next/router';
import { ReviewStyle } from '../../../styles/components/common/blocks';
import { Button } from '../ui';

export interface IReviewProps {
  title: string;
  subTitle: string;
  description: string;
  review: {
    text: string;
    username: string;
    score: number;
    date: string;
    link?: string;
  };
  buttonLabel: string;
  buttonPath: string;
}

const Reviews = (props: IReviewProps) => {
  const router = useRouter();

  return (
    <div className={ReviewStyle.ReviewWrapper}>
      <div className={ReviewStyle['ReviewContent']}>
        <div className={ReviewStyle['ReviewContentLeft']}>
          <h2>{props.title}</h2>
          <h3>{props.subTitle}</h3>
          <p>{props.description}</p>
          <Button
            color="outline"
            onClick={() => router.push(`${props.buttonPath}`)}>
            {props.buttonLabel}
          </Button>
        </div>
        <div className={ReviewStyle['ReviewContentRight']}>
          <span className={ReviewStyle['Quotes']}>&quot;</span>
          <div className={ReviewStyle['ReviewContentRightText']}>
            <p>{props.review.text}</p>
            <div className={ReviewStyle.ReviewDataBottomWrap}>
              <div className={ReviewStyle['ReviewDataBottom']}>
                <h4>{props.review.username}</h4>
                <p>{props.review.date}</p>
              </div>
              <div className={ReviewStyle.starsWrap}>
                {props.review?.score
                  ? [...Array(5)].map((item: any, index: number) => {
                      return (
                        <Image
                          quality={90}
                          src="/assets/images/icons/StarIcon.svg"
                          alt="star"
                          width={20}
                          height={20}
                          priority={false}
                          key={index}
                          className={
                            props.review.score - index > 0
                              ? ReviewStyle['star-active']
                              : undefined
                          }
                        />
                      );
                    })
                  : ' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
